;(function () {
  'use strict'

  angular
    .module('contrast.security-controls')
    .factory(
      'securityControlService',
      function securityControlServiceFactory(
        securityControlApiConfig,
        ServiceUtils,
        SECURITY_CONTROL_TYPES
      ) {
        'ngInject'

        return {
          getControlTypes: getControlTypes,
          getUserDefineControlTypes: getUserDefineControlTypes,

          getSecurityControls: getSecurityControls,
          getSecurityControlsQuickFilters: getSecurityControlsQuickFilters,
          getSecurityControl: getSecurityControl,
          updateSecurityControl: updateSecurityControl,
          toogleControlEnabled: toogleControlEnabled,
          deleteSecurityControl: deleteSecurityControl,

          addValidator: addValidator,
          addValidatorFromTrace: addValidatorFromTrace,

          addSanitizer: addSanitizer,
          addSanitizerFromTrace: addSanitizerFromTrace,

          getSuggestedControls: getSuggestedControls,
          removeSuggestedControl: removeSuggestedControl,
          addSuggestedControl: addSuggestedControl,
          undoSuggestedControl: undoSuggestedControl,
          markApi: markApi,

          filterRelevantAgentLanguages: filterRelevantAgentLanguages,
          getAgentLanguageKeys: getAgentLanguageKeys
        }

        function getControlTypes() {
          return [
            SECURITY_CONTROL_TYPES.INPUT_VALIDATOR,
            SECURITY_CONTROL_TYPES.SANITIZER,
            SECURITY_CONTROL_TYPES.PATTERN_VALIDATOR
          ]
        }

        function getUserDefineControlTypes() {
          return [
            SECURITY_CONTROL_TYPES.INPUT_VALIDATOR,
            SECURITY_CONTROL_TYPES.SANITIZER
          ]
        }

        function getSecurityControls(params) {
          return securityControlApiConfig
            .getSecurityControls(params)
            .then(ServiceUtils.handleResolve('data.controls'))
            .catch(ServiceUtils.handleError)
        }

        function getSecurityControlsQuickFilters(data) {
          return securityControlApiConfig
            .getSecurityControlsQuickFilters(data)
            .then(ServiceUtils.handleResolve('data.filters'))
            .catch(ServiceUtils.handleError)
        }

        function getSecurityControl(controlId) {
          return securityControlApiConfig
            .getSecurityControl(controlId)
            .then(ServiceUtils.handleResolve('data.control'))
            .catch(ServiceUtils.handleError)
        }

        function updateSecurityControl(id, control) {
          return securityControlApiConfig
            .updateSecurityControl(id, control)
            .then(ServiceUtils.handleResolve('data.messages'))
            .catch(ServiceUtils.handleError)
        }

        function toogleControlEnabled(id) {
          return securityControlApiConfig
            .toogleControlEnabled(id)
            .then(ServiceUtils.handleResolve('data.messages'))
            .catch(ServiceUtils.handleError)
        }

        function deleteSecurityControl(id) {
          return securityControlApiConfig
            .deleteSecurityControl(id)
            .then(ServiceUtils.handleResolve('data.messages'))
            .catch(ServiceUtils.handleError)
        }

        function addValidator(data) {
          return securityControlApiConfig
            .addValidator(data)
            .then(ServiceUtils.handleResolve('data.messages'))
            .catch(ServiceUtils.handleError)
        }

        function addValidatorFromTrace(data, traceUuid) {
          return securityControlApiConfig
            .addValidatorFromTrace(data, traceUuid)
            .then(ServiceUtils.handleResolve('data.messages'))
            .catch(ServiceUtils.handleError)
        }

        function addSanitizer(data) {
          return securityControlApiConfig
            .addSanitizer(data)
            .then(ServiceUtils.handleResolve('data.messages'))
            .catch(ServiceUtils.handleError)
        }

        function addSanitizerFromTrace(data, traceUuid) {
          return securityControlApiConfig
            .addSanitizerFromTrace(data, traceUuid)
            .then(ServiceUtils.handleResolve('data.messages'))
            .catch(ServiceUtils.handleError)
        }

        function getSuggestedControls(params) {
          return securityControlApiConfig
            .getSuggestedControls(params)
            .then(ServiceUtils.handleResolve('data.suggestions'))
            .catch(ServiceUtils.handleError)
        }

        function removeSuggestedControl(id) {
          return securityControlApiConfig
            .removeSuggestedControl(id)
            .then(ServiceUtils.handleResolve('data.messages'))
            .catch(ServiceUtils.handleError)
        }

        function addSuggestedControl(id, form) {
          return securityControlApiConfig
            .addSuggestedControl(id, form)
            .catch(ServiceUtils.handleError)
        }

        function undoSuggestedControl(id) {
          return securityControlApiConfig
            .undoSuggestedControl(id)
            .then(ServiceUtils.handleResolve('data.suggestion'))
            .catch(ServiceUtils.handleError)
        }

        function markApi(api, language) {
          return securityControlApiConfig
            .markApi(api, language)
            .then(ServiceUtils.handleResolve('data.api'))
            .catch(ServiceUtils.handleError)
        }

        function filterRelevantAgentLanguages(agentLanguages) {
          return agentLanguages.filter(function (agentLanguage) {
            return (
              agentLanguage.key === 'JAVA' ||
              agentLanguage.key === 'DOTNET' ||
              agentLanguage.key === 'DOTNET_CORE'
            )
          })
        }

        function getAgentLanguageKeys(agentLangauges) {
          return agentLangauges.map(function (agentLanguage) {
            return agentLanguage.value
          })
        }
      }
    )
})()
